export default "__VITE_ASSET__BSChm2FX__"